import Event from '../events';
//Mactrix additions begin
import MuxJsInline from '../../muxjs-inline';  //mux js wrapper
import MuxJsWorker from '../../muxjs-worker';  //mux js web worker
import Webworkify from 'webworkify';					// browersify only
import WebworkifyWebpack from 'webworkify-webpack';		// webpack only
import MactrixDecrypter from '../../aes/MactrixDecrypter';
//Mactrix additions end
import {logger} from '../utils/logger';
import {ErrorTypes, ErrorDetails} from '../errors';
import EventEmitter from 'events';

class Demuxer {

  constructor(hls, id) {
    this.hls = hls;
    this.id = id;
//Mactrix changes begin
	this.enableMuxJs = !!hls.config.enableMuxJs; //switch between the use of hls js transmuxer and mux js transmuxer
	this.decryptOutsideWebworker = !!hls.config.decryptOutsideWebworker; //for platforms that don't support decyption in Webworkers
	this.decrypter = null;
//Mactrix changes end
    // observer setup
    const observer = this.observer = new EventEmitter();
/*Mactrix replace
	const config = hls.config;
Mactrix replace*/
	const config = this.config = hls.config; //Mactrix addition; need to retain
    observer.trigger = function trigger (event, ...data) {
      observer.emit(event, event, ...data);
    };

    observer.off = function off (event, ...data) {
      observer.removeListener(event, ...data);
    };

    var forwardMessage = function(ev,data) {
      data = data || {};
      data.frag = this.frag;
      data.id = this.id;
      hls.trigger(ev,data);
    }.bind(this);

    // forward events to main thread
    observer.on(Event.FRAG_DECRYPTED, forwardMessage);
    observer.on(Event.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
    observer.on(Event.FRAG_PARSING_DATA, forwardMessage);
    observer.on(Event.FRAG_PARSED, forwardMessage);
    observer.on(Event.ERROR, forwardMessage);
    observer.on(Event.FRAG_PARSING_METADATA, forwardMessage);
    observer.on(Event.FRAG_PARSING_USERDATA, forwardMessage);
    observer.on(Event.INIT_PTS_FOUND, forwardMessage);

    const typeSupported = {
      mp4 : MediaSource.isTypeSupported('video/mp4'),
      mpeg: MediaSource.isTypeSupported('audio/mpeg'),
/* Mactrix changed line
      mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
*/
// Mactrix changes begin
      mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
      browChrome: hls.browChrome,
      browSafari: hls.browSafari,
      browFirefox: hls.browFirefox,
      browAndroid: hls.browAndroid,
	  browEdge: hls.browEdge,
	  browIE: hls.browIE
// Mactrix changes end
    };
    // navigator.vendor is not always available in Web Worker
    // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
    const vendor = navigator.vendor;
    //if(false) {
	if (config.enableWorker && (typeof(Worker) !== 'undefined')) {
		logger.log('demuxing in webworker');
        let w;
        try {
/* mactrix replace
			let work = require('webworkify');
			w = this.w = work(DemuxerWorker);
*/
			//Mactrix changes begin
			// if we're using WebPack we need to use webworkify-webpack rather than webworkify
			if( typeof __webpack_modules__ === 'undefined' ) {
				w = this.w = Webworkify(MuxJsWorker);
			}
			else {
				w = this.w = WebworkifyWebpack(require.resolve('../../muxjs-worker'));
			}
			//Mactrix changes end
			this.onwmsg = this.onWorkerMessage.bind(this);
			w.addEventListener('message', this.onwmsg);
			w.onerror = function(event) { hls.trigger(Event.ERROR, {type: ErrorTypes.OTHER_ERROR, details: ErrorDetails.INTERNAL_EXCEPTION, fatal: true, event : 'demuxerWorker', err : { message : event.message + ' (' + event.filename + ':' + event.lineno + ')' }});};
			w.postMessage({cmd: 'init', typeSupported : typeSupported, vendor : vendor, id : id, config: JSON.stringify(config)});
        } catch(err) {
			logger.error('error while initializing DemuxerWorker, fallback on DemuxerInline');
			hls.trigger(Event.ERROR, {type: ErrorTypes.MUX_ERROR, details: ErrorDetails.DEMUX_WORKER_ALLOC_ERROR, fatal: false}); //Mactrix line added, emit errors
			if (w) {
				// revoke the Object URL that was used to create demuxer worker, so as not to leak it
				URL.revokeObjectURL(w.objectURL);
			}
//Mactrix changes begin
			this.demuxer = new MuxJsInline(observer,typeSupported,config,vendor);
//Mactrix changes end
		  	this.w = undefined;
        }
    } else {
//Mactrix changes begin
        this.demuxer = new MuxJsInline(observer,typeSupported,config,vendor);
//Mactrix changes end
	}
  }

  destroy() {
    let w = this.w;
    if (w) {
      w.removeEventListener('message', this.onwmsg);
      w.terminate();
      this.w = null;
    } else {
      let demuxer = this.demuxer;
      if (demuxer) {
        demuxer.destroy();
        this.demuxer = null;
      }
    }
    let observer = this.observer;
    if (observer) {
      observer.removeAllListeners();
      this.observer = null;
    }
  }

  push(data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, lastFragAborted, deliberateGap) {
    const w = this.w;
    const timeOffset = !isNaN(frag.startDTS) ? frag.startDTS  : frag.start;
    const decryptdata = frag.decryptdata;
    const lastFrag = this.frag;
    const discontinuity = !(lastFrag && (frag.cc === lastFrag.cc));
	const trackSwitch = !(lastFrag && (frag.level === lastFrag.level));
	const pdt = frag.pdt;
/*Mactrix replace
    const nextSN = lastFrag && (frag.sn === (lastFrag.sn+1));
    const contiguous = !discontinuity && !trackSwitch && nextSN;
*/
//Mactrix changes begin: in the case muxjs (to make the code simpler) contiguous will mean if we seeked or not, ie; nextSN is true or false
	//this needs to be based on pdt if available, we still have an issue with duplicate
	//frags, most likely occurs when we hit the edge of a live playlist and we end up selecting
	//the last frag again instead of waiting for a refresh ... needs to be fixed.
	let nextSN;
	let contiguous;
	let hasBeenProcessed = false;

	if(this.enableMuxJs === true) {
		if(lastFrag) {
			if(lastFrag.pdt && frag.pdt) {
				let expectedTime = lastFrag.pdt + lastFrag.manifestDuration * 1000;
				let variance = lastFrag.manifestDuration * 500; //variance is 1/2 a manifest duration

				//for the next frag to be in sequence it needs to begin at the end of the previous frag (or be the same as the current frag)
				//we will allow up to but not including 1/2 a manifest duration of variance

				if( frag.pdt > lastFrag.pdt - variance && frag.pdt < lastFrag.pdt + variance ) {
					//this is the same frag ... we need to reset
					contiguous = true;
				} else {
					if( frag.pdt > expectedTime - variance && frag.pdt < expectedTime + variance) {
						//for the sake of simplicity, contiguous indicates whether or not we have seeked .... its backwards ... I know ... change me!
						contiguous = false;
					} else {
						contiguous = !deliberateGap;
					}
				}
			}
			else {
				nextSN = (frag.sn === (lastFrag.sn+1));
				contiguous = !(nextSN === true || deliberateGap);
			}
		}
		else {
			contiguous = true;
		}

		//to avoid additional changes I'm using the accurateTimeOffset parameter as the disco gap since the parameter is not used in muxjs
		accurateTimeOffset = frag.gap;
	}
//Mactrix changes end

	//This block is for decryptOutsideWebworker. There's supporting code for this, but the major changes should be mostly self contained; if you delete this block nothing should break.
	if (this.decryptOutsideWebworker === true && w && (decryptdata != null) && ((data.byteLength > 0) && (decryptdata.key != null) && (decryptdata.method === 'AES-128'))) {

		let decrypter = this.decrypter;
		if (decrypter === null) {
			decrypter = this.decrypter = new MactrixDecrypter(this.observer, this.config);
		}
		var localthis = this;
		let startTime;
		hasBeenProcessed = true;

		try {
			startTime = performance.now();
		}
		catch(error) {
			startTime = Date.now();
		}

		decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
			let endTime;
			try {
				endTime = performance.now();
			}
			catch(error) {
				endTime = Date.now();
			}
			localthis.observer.trigger(Event.FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
			w.postMessage({cmd: 'demux', data:decryptedData, decryptdata:null, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, lastFragAborted, pdt}, [data]);
		});
	}

//Mactrix changes end
    if (discontinuity) {
      logger.log(`${this.id}:discontinuity detected`);
    }
    if (trackSwitch) {
      logger.log(`${this.id}:switch detected`);
    }
    this.frag = frag;
//Mactrix changes start
	if (!hasBeenProcessed) {
//Mactrix changes end
    if (w) {
      // post fragment payload as transferable objects (no copy)
      w.postMessage({cmd: 'demux', data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, lastFragAborted, pdt }, [data]);
    } else {
      let demuxer = this.demuxer;
      if (demuxer) {
        demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset,lastFragAborted, pdt);
      }
    }
//Mactrix changes start
  }
//Mactrix changes end
  }

  onWorkerMessage(ev) {
    let data = ev.data,
        hls = this.hls;
    //console.log('onWorkerMessage:' + data.event);
    switch(data.event) {
      case 'init':
        // revoke the Object URL that was used to create demuxer worker, so as not to leak it
        URL.revokeObjectURL(this.w.objectURL);
        break;
      // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
      case Event.FRAG_PARSING_DATA:
        data.data.data1 = new Uint8Array(data.data1);
        if (data.data2) {
          data.data.data2 = new Uint8Array(data.data2);
        }
        /* falls through */
      default:
        data.data = data.data || {};
        data.data.frag = this.frag;
        data.data.id = this.id;
        hls.trigger(data.event, data.data);
        break;
    }
  }
}

export default Demuxer;



// WEBPACK FOOTER //
// ./src/hlsjs/demux/demuxer.js